import Stack from "@mui/material/Stack";
import type { Overwrite } from "@mui/types";
import { theme } from "@polifonia/theme";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button";
import type { ModalProps } from "@/components/Modal";
import { Modal } from "@/components/Modal";
import { Typography } from "@/components/Typography";

namespace DeleteAccountModal {
  export interface OwnProps {
    accountName: string;
    open: boolean;
    isLoading: boolean;
    onClose: () => void;
    onConfirm: () => void;
  }

  export type Props = Overwrite<
    Omit<ModalProps, "children" | "handleClose">,
    OwnProps
  >;
}

export const DeleteAccountModal: React.FC<DeleteAccountModal.Props> = ({
  open,
  isLoading,
  onClose,
  onConfirm,
  accountName,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      handleClose={onClose}
      title={t("applications.googleAds.deleteAccountModal.title")}
      footer={
        <Stack direction="row" justifyContent="flex-end" gap="12px">
          <Button variant="secondary" onClick={onClose} disabled={isLoading}>
            {t("common.cancel")}
          </Button>
          <Button variant="danger" onClick={onConfirm} loading={isLoading}>
            {t("common.delete")}
          </Button>
        </Stack>
      }
    >
      <Stack gap="16px">
        <Typography variant="body" color={theme.colors.staticFgBody}>
          {t("applications.googleAds.deleteAccountModal.message", {
            name: accountName,
          })}
        </Typography>
      </Stack>
    </Modal>
  );
};
